import React from 'react';
import { formatBytes, parseServerTime } from '../utils/format';
import '../../styles/shared/UsageMeter.css';

function usageLevel(percent) {
  if (percent >= 90) return 'high';
  if (percent >= 75) return 'warn';
  return 'ok';
}

/**
 * Storage usage bar. `compact` is the one-line version for service rows;
 * the full version adds used / free / total figures and the update time.
 */
function UsageMeter({ usage, compact = false }) {
  if (!usage || !Number.isFinite(Number(usage.total_bytes))) return null;

  const percent = Math.min(100, Math.max(0, Number(usage.usage_percent) || 0));
  const level = usageLevel(percent);
  const fill = (
    <div className="usage-meter_track" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
      <div className={`usage-meter_fill usage-meter_fill--${level}`} style={{ width: `${percent}%` }} />
    </div>
  );

  if (compact) {
    return (
      <div className="usage-meter usage-meter--compact" title={`${formatBytes(usage.used_bytes)} of ${formatBytes(usage.total_bytes)} used`}>
        {fill}
        <span className="usage-meter_caption">
          {formatBytes(usage.used_bytes)} / {formatBytes(usage.total_bytes)} · {percent.toFixed(1)}%
        </span>
      </div>
    );
  }

  const updated = parseServerTime(usage.updated_at);

  return (
    <div className="usage-meter">
      <div className="usage-meter_headline">
        <strong className={`usage-meter_percent usage-meter_percent--${level}`}>{percent.toFixed(1)}%</strong>
        <span>used</span>
      </div>
      {fill}
      <div className="usage-meter_figures">
        <div><span>Used</span><strong>{formatBytes(usage.used_bytes)}</strong></div>
        <div><span>Free</span><strong>{formatBytes(usage.available_bytes)}</strong></div>
        <div><span>Total</span><strong>{formatBytes(usage.total_bytes)}</strong></div>
      </div>
      {updated && (
        <p className="usage-meter_updated">Updated {updated.toLocaleString()}</p>
      )}
    </div>
  );
}

export default UsageMeter;
